import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LeaveApplicationListPage } from '@/features/leaveApplications/pages/LeaveApplicationListPage';
import { leaveApplicationSearchSchema } from '@/features/leaveApplications/types/filters.types';

export const Route = createFileRoute('/_auth/hr-form/leave-applications/')({
  validateSearch: leaveApplicationSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Leave Applications">
      <Suspense fallback={<PageLoader />}>
        <LeaveApplicationListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
